// extracted by mini-css-extract-plugin
export var container = "_ab-0";
export var icon = "_ab-1";
export var text = "_ab-2";